import { CultureKeyType } from '@constants/app.constants';
import { createAction, props } from '@ngrx/store';

export const enum CultureActionTypes {
  updateCultureCode = '[culture] UPDATE_CULTURE_CODE',
  updateSelectedCurrencyCode = '[culture] UPDATE_SELECTED_CURRENCY_CODE',
  updateGeolocationFallback = '[culture] UPDATE_GEOLOCATION_FALLBACK',
}

export const enum CultureCodeUpdateType {
  Url = 'url',
  Selection = 'selection',
  Geolocation = 'geolocation',
}

export const updateCultureCode = createAction(
  CultureActionTypes.updateCultureCode,
  props<{
    from: CultureCodeUpdateType;
    code: CultureKeyType;
  }>(),
);

export const updateSelectedCurrencyCode = createAction(
  CultureActionTypes.updateSelectedCurrencyCode,
  props<{
    code: string;
    isFlightsPage: boolean;
  }>(),
);

export const updateGeolocationFallback = createAction(
  CultureActionTypes.updateGeolocationFallback,
);
